/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import gql from 'graphql-tag';

export const USER = gql`
  query User {
    user {
      id
      name
      avatarUrl
      role
      type
      languages
    }
  }
`;

export const USER_PROFILE = gql`
  query UserProfile($id: String!) {
    userProfile(id: $id) {
      createdAt
      updatedAt
      id
      name
      avatarUrl
      jobTitle
      bio
      userLinks {
        name
        url
      }
    }
  }
`;
